import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import ESuranceApi from '../generated/api/ESurance';

export default (service: Servicelayer) => ({
  ...ESuranceApi(service),

  // Add custom calls here

});
